// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contractor-container {
  margin-bottom: 15px;
  background: #f9f9f9;
  border-radius: 5px;
}

.contractor-header {
  padding: 15px 20px;
  cursor: pointer;
  font-weight: bold;
  color: #0e0635;
  transition: background-color 0.3s;
}

.contractor-header:hover {
  background-color: #e8e8e8;
}

.contractor-details {
  padding: 20px;
  border-top: 1px solid #ddd;
}

.info-section,
.users-section,
.restaurants-section {
  margin-bottom: 20px;
}

.info-section h3,
.users-section h3,
.restaurants-section h3 {
  color: #34495e;
  margin-bottom: 10px;
}

ul {
  list-style-type: none;
  padding-left: 0;
}

li {
  margin-bottom: 8px;
}

.restaurant-name {
  cursor: pointer;
  color: #2980b9;
  transition: color 0.3s;
}

.restaurant-name:hover {
  color: #3498db;
}

.restaurant-fops {
  margin-top: 10px;
  padding-left: 20px;
}

`, "",{"version":3,"sources":["webpack://./src/components/directory/Directory.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".contractor-container {\r\n  margin-bottom: 15px;\r\n  background: #f9f9f9;\r\n  border-radius: 5px;\r\n}\r\n\r\n.contractor-header {\r\n  padding: 15px 20px;\r\n  cursor: pointer;\r\n  font-weight: bold;\r\n  color: #0e0635;\r\n  transition: background-color 0.3s;\r\n}\r\n\r\n.contractor-header:hover {\r\n  background-color: #e8e8e8;\r\n}\r\n\r\n.contractor-details {\r\n  padding: 20px;\r\n  border-top: 1px solid #ddd;\r\n}\r\n\r\n.info-section,\r\n.users-section,\r\n.restaurants-section {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.info-section h3,\r\n.users-section h3,\r\n.restaurants-section h3 {\r\n  color: #34495e;\r\n  margin-bottom: 10px;\r\n}\r\n\r\nul {\r\n  list-style-type: none;\r\n  padding-left: 0;\r\n}\r\n\r\nli {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.restaurant-name {\r\n  cursor: pointer;\r\n  color: #2980b9;\r\n  transition: color 0.3s;\r\n}\r\n\r\n.restaurant-name:hover {\r\n  color: #3498db;\r\n}\r\n\r\n.restaurant-fops {\r\n  margin-top: 10px;\r\n  padding-left: 20px;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
